const WEIGHTS = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];

/* 
For testing:

These are WORKING ABNs:

33 051 775 556 should work
14 069 979 460 should work
24 302 976 253 should work

These are INVALID ABNs:

65 065 987 968 should fail
12 345 678 965 should fail
*/

/**
 * @function isValidABN This function checks if the number input is a valid Australian Business Number ABN)
 * @param {number | string} input
 * @returns {boolean}
 */

export const isValidABN = (input: string | number): boolean => {
  if (typeof input !== 'string' && typeof input !== 'number') return false;

  const abnInput = `${input}`.replace(/ /g, '');

  if (!abnInput || abnInput.length !== 11) {
    return false;
  }

  const checksum = abnInput
    .split('')
    .map(Number)
    .reduce(function (total, digit, index) {
      if (!index) {
        digit--;
      }
      return total + digit * WEIGHTS[index];
    }, 0);

  if (!checksum || checksum % 89 !== 0) {
    return false;
  }

  return true;
};
